<script>
import { Row, Col, Cell, Image, Form, Field, Toast } from 'vant'
import AreaSelector from '@/components/org/AreaSelector'
import PickerSelector from '@/components/org/PickerSelector'
import CalendarSelector from '@/components/org/CalendarSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import MatchRule from '@/tbs/model/vo/MatchRule'
import { QNImageUtil } from '@/utils'
import { getPOI } from '@/libs/ds-bridge'

const matchRule = new MatchRule

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-cell': Cell,
        'van-image': Image,
        'van-form': Form,
        'van-field': Field,
        'area-selector': AreaSelector,
        'picker-selector': PickerSelector,
        'calendar-selector': CalendarSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {
                organizationId: null,
                brandId: null,
                brandName: null,
                brandLogoUrl: null,
                name: null,
                logoUrl: null,
                areaId: null,
                area: null,
                numSelection: null,
                type: null,
                startDate: null,
                fieldLocation: null,
                teamTotal: null,
                year: null,
                session: null,
            },
            cityRegion: {
                areaList: null,
                areaIdList: null
            },
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        submitBtnClass() {
            return {
                'van-button--disabled': !this.validateSubmitRequired()
            }
        },
        numSelectionIndex() {
            return matchRule.numSelectionIndex
        },
        numSelectionOptions() {
            return matchRule.numSelectionOptions
        },
        matchTypeOptions() {
            return matchRule.matchTypeOptions
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    mounted() {
        window.handleBMPOI = function(poi) {
            //返回的poi 是json串.
            alert(poi);
        }
    },
    methods: {
        getPOI() {
            //这边先写死上海了
            getPOI({'cityId':'5643', 'cityName': '上海'});
        },
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.match.numSelection) {
                    Toast(this.locale['match-num-selection-required'])
                }
                else if (!this.match.type) {
                    Toast(this.locale['match-type-required'])
                }
                else if (!this.match.startDate) {
                    Toast(this.locale['match-start-date-required'])
                }
                else if (!this.match.teamTotal) {
                    Toast(this.locale['match-team-total-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onAreaSelectorDataChange(data) {
            console.log('onAreaSelectorDataChange', this.isEdit, data)
            this.match.areaId = this.convertAreaCode2Id(data.code)
            this.match.area = data.label
        },
        onNumSelectionDataChange(data) {
            this.match.numSelection = data.value
        },
        onTypeDataChange(data) {
            this.match.type = data.value
        },
        onStartDateDataChange(data) {
            this.match.startDate = data
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.match.numSelection 
                && this.match.type 
                && this.match.startDate
                && this.match.teamTotal) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'submit',
                    data: this.match
                })
            }
        },
        convertAreaCode2Id(code) {
            console.log('convertAreaCode2Id', code)
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                if (areaIdList.province_list[code]) {
                    return areaIdList.province_list[code]
                }
                else if (areaIdList.city_list[code]) {
                    return areaIdList.city_list[code]
                }
                else if (areaIdList.county_list[code]) {
                    return areaIdList.county_list[code]
                }
            }
            return '1'
        },
        convertAreaId2Code(id) {
            if (this.cityRegion && this.cityRegion.areaIdList) {
                const areaIdList = this.cityRegion.areaIdList
                for (let p in areaIdList.province_list) {
                    if (areaIdList.province_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.city_list) {
                    if (areaIdList.city_list[p] == id) {
                        return p
                    }
                }
                for (let p in areaIdList.county_list) {
                    if (areaIdList.county_list[p] == id) {
                        return p
                    }
                }
            }
        },
    },
}
</script>

<template>
    <div class="match-edit">
        <van-row class="bg-white b-outer-margin u-inner-padding">
            <van-col span="2" class="vertical-center cell-height ">
                <van-image 
                    :src="adjustImageSize(match.logoUrl, 60, 60)"
                    round center
                    fit="cover"
                    width="30px"
                    height="30px"
                />
            </van-col>
            <van-col span="22" class="name-field vertical-center">
                <van-cell :value="match.name"/>
            </van-col>
        </van-row>
        <van-form>
            <div @click="getPOI">点击获取poi</div>
            <area-selector
                :label="locale['city-region']"
                :all="locale['all']"
                :areaList="cityRegion.areaList"
                :selectedAreaCode="convertAreaId2Code(match.areaId)"
                :selectedAreaLabel="match.area"
                @change-data="onAreaSelectorDataChange"
            />
            <picker-selector
                :label="locale['match-num-selection-label']"
                :options="numSelectionOptions"
                :index="numSelectionIndex"
                @change-data="onNumSelectionDataChange"
            />
            <picker-selector
                :label="locale['match-type-label']"
                :options="matchTypeOptions"
                @change-data="onTypeDataChange"
            />
            <calendar-selector
                :label="locale['match-start-date-label']"
                :dateFormat="locale['match-date-format']"
                @change-data="onStartDateDataChange"
            />
            <van-field
                v-model="match.teamTotal"
                :label="locale['match-team-total-label']"
                type="digit"
                clearable
                input-align="right"
                maxlength="3"
            />
        </van-form>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
    </div>
</template>

<style scoped>
.name-field .van-cell__value--alone {
    text-align: left !important;
}
</style>